<template>
  <div class="group-profile-info">
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="集团概况"/>
      <div class="header-btn-box">
        <a @click="toModifyPage">修改</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">集团名称：</div>
        <div class="line-info">{{formData.groupName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">集团电话：</div>
        <div class="line-info">{{formData.groupTelephone || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">集团地址：</div>
        <div class="line-info">{{formData.groupAddress || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">集团简介：</div>
        <div class="line-info">{{formData.groupIntroduce || '无'}}</div>
      </div>
      <div class="form-line" style="height: 90px;line-height: 90px;">
        <div class="line-text" style="height: 90px;line-height: 90px;">集团logo：</div>
        <div class="line-info" style="height: 90px;line-height: 90px;">
          <img :src="formData.groupLogo" alt="" v-if="formData.groupLogo" style="width: 120px;height: 90px;max-width: 150px;border-radius: 5px;">
          <span v-if="!formData.groupLogo">无</span>
        </div>
      </div>
      <div class="form-line">
        <div class="line-text">集团展示：</div>
        <div style="width: 320px;height: 180px;" v-if="groupPicList.length !== 0">
          <el-carousel height="180px">
            <el-carousel-item v-for="item in groupPicList" :key="item">
              <img :src="item" alt="" style="width: 320px;height: 180px;">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-if="groupPicList.length === 0">无</div>
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../../components/Text/TextTitle'
  import {api} from '../../../../api/Summary'
  import {errorHandler} from '../../../../../utils/errorHandler'

  export default {
    components: {
      TextTitle,
      Breadcrumb
    },
    name: 'group-profile-info',
    data () {
      return {
        breadcrumb: [{
          value: '信息发布',
          name: 'group-profile-info'
        }, {
          value: '集团概况'
        }],
        mainTitle: '集团概况',
        groupIntroduce: '',
        formData: {
          groupName: '',  // 集团名称
          groupIntroduce: '', // 集团简介
          groupTelephone: '', // 集团电话
          groupAddress: '', // 集团地址
          groupLogo: '', // 集团logo
          groupPic1: '',
          groupPic2: '',
          groupPic3: '',
          groupPic4: '',
          groupPic5: '',
        },
        groupPicList: []
      }
    },
    created () {
      this.getGroupInfo()
    },
    methods: {
      toModifyPage () {
        this.$router.push({
          name: 'upper-information-group-profile-info-modify'
        })
      },

      getGroupInfo () {
        this.$axios.post(api.getGroupInfo, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.formData = data
              this.groupIntroduce = data.groupIntroduce.split('\n')
              if (data.groupPic1) {
                this.groupPicList.push(data.groupPic1)
              }
              if (data.groupPic2) {
                this.groupPicList.push(data.groupPic2)
              }
              if (data.groupPic3) {
                this.groupPicList.push(data.groupPic3)
              }
              if (data.groupPic4) {
                this.groupPicList.push(data.groupPic4)
              }
              if (data.groupPic5) {
                this.groupPicList.push(data.groupPic5)
              }
              console.log(this.groupPicList)
            }
          })
          .catch(errorHandler('查询信息失败'))
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 50px;
  }
  .form-line>div {
    display: flex;

  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 100px;
    height: 50px;
    line-height: 50px;
    text-align: right;
  }
  .line-info {
    width: 180px;
    height: 50px;
    line-height: 50px;
  }
</style>

<style lang="less">
  .group-profile-info {
    .el-carousel__button {
      width: 10px !important;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/InformationDelivery/GroupProfile/GroupProfileInfo.vue